import { Injectable } from '@angular/core';
import { ImpedimentoAfericao } from '@tivic-team/manager-ts/dist/mob/entities/concessao/impedimento-afericao.entity';
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environmentv3 } from 'src/environments/environmentv3';
import { ApiController } from '../api-controller.interface';

@Injectable()
export class ImpedimentoAfericaoController implements ApiController<ImpedimentoAfericao>{

    find(filters?: IFilter): Promise<ImpedimentoAfericao[]> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/impedimentoafericao',
                    environment: environmentv3,
                    filter: filters,
                }),
            }),
            new HttpResponse(new Array<ImpedimentoAfericao>())
        );
        return request.call();
    }

    get(id: number): Promise<ImpedimentoAfericao> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/impedimentoafericao/:cdImpedimentoAfericao',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdImpedimentoAfericao: id
                    }),
                }),
            }),
            new HttpResponse(new ImpedimentoAfericao())
        );
        return request.call();
    }

    create(entity: ImpedimentoAfericao): Promise<ImpedimentoAfericao> {
        let request = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'mob/impedimentoafericao',
                    environment: environmentv3
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new ImpedimentoAfericao()
            )
        );
        return request.call();
    }
    
    update(entity: ImpedimentoAfericao): Promise<ImpedimentoAfericao> {
        let request = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/impedimentoafericao/:cdImpedimentoAfericao',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdImpedimentoAfericao: entity.cdImpedimentoAfericao
                    })
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new ImpedimentoAfericao()
            )
        );
        return request.call();
    }
}